import tw from "twin.macro";

export const Card = tw.div`rounded-2xl p-12 xl:p-10 shadow
text-indigo-600 bg-stone-50 border ring-0
transition
hover:(ring ring-indigo-400 shadow-md)
active:(ring ring-indigo-600 shadow-md)
focus-visible:(outline outline-2 outline-offset-2 outline-indigo-600)`;

export const CustomCard = tw.div`rounded-2xl p-4
 bg-stone-50 border ring-0 transition`;
